// ABOUTME: Distance icon for workout distance type
// ABOUTME: Drawn in currentColor — `color` when given, else the icon grey (`text-icon`), so it follows the theme

import { cn } from "@shared/lib/utils"

interface DistIconProps {
  className?: string
  size?: number
  color?: string
}

export const DistIcon = ({ className = "", size = 16, color }: DistIconProps) => (
  <svg
    className={cn("text-icon", className)}
    style={color ? { color } : undefined}
    xmlns="http://www.w3.org/2000/svg"
    width={size * 0.875}
    height={size}
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M5.65252 5.98324C6.56374 5.07202 6.56374 3.59463 5.65252 2.68341C4.7413 1.77218 3.26391 1.77218 2.35269 2.68341C1.44146 3.59463 1.44146 5.07202 2.35269 5.98324L4.0026 7.63312L5.65252 5.98324ZM4.0026 9.51879L1.40988 6.92606C-0.0220425 5.49412 -0.0220425 3.17252 1.40988 1.7406C2.8418 0.308676 5.1634 0.308676 6.59534 1.7406C8.02727 3.17252 8.02727 5.49412 6.59534 6.92606L4.0026 9.51879ZM4.0026 5.33332C3.45032 5.33332 3.0026 4.88561 3.0026 4.33332C3.0026 3.78104 3.45032 3.33332 4.0026 3.33332C4.55489 3.33332 5.0026 3.78104 5.0026 4.33332C5.0026 4.88561 4.55489 5.33332 4.0026 5.33332ZM10.0026 13.6331L11.6525 11.9833C12.5637 11.072 12.5637 9.59466 11.6525 8.68339C10.7413 7.77219 9.26394 7.77219 8.35267 8.68339C7.44147 9.59466 7.44147 11.072 8.35267 11.9833L10.0026 13.6331ZM12.5953 12.9261L10.0026 15.5188L7.40987 12.9261C5.97794 11.4941 5.97794 9.17252 7.40987 7.74059C8.8418 6.30868 11.1634 6.30868 12.5953 7.74059C14.0273 9.17252 14.0273 11.4941 12.5953 12.9261ZM10.0026 11.3333C9.45034 11.3333 9.0026 10.8856 9.0026 10.3333C9.0026 9.78106 9.45034 9.33332 10.0026 9.33332C10.5549 9.33332 11.0026 9.78106 11.0026 10.3333C11.0026 10.8856 10.5549 11.3333 10.0026 11.3333Z"
      fill="currentColor"
    />
  </svg>
)
